import { descriptorsFactory } from '../../utils/filters';

export const roomsDescriptor = descriptorsFactory({
  clear: [],
  name: 'Rooms',
})(
  {
    form: [{ key: 'room', type: 'terms', value: ['oneRoom'] }],
    label: '1-комнатная',
    shortLabel: '1',
    state: 'oneRoom',
  },
  {
    form: [{ key: 'room', type: 'terms', value: ['twoRoom'] }],
    label: '2-комнатная',
    shortLabel: '2',
    state: 'twoRoom',
  },
  {
    form: [{ key: 'room', type: 'terms', value: ['threeRoom'] }],
    label: '3-комнатная',
    shortLabel: '3',
    state: 'threeRoom',
  },
  {
    form: [{ key: 'room', type: 'terms', value: ['fourRoom'] }],
    label: '4-комнатная',
    shortLabel: '4',
    state: 'fourRoom',
  },
  {
    form: [{ key: 'room', type: 'terms', value: ['fiveRoom'] }],
    label: '5-комнатная',
    shortLabel: '5',
    state: 'fiveRoom',
  },
  {
    form: [{ key: 'room', type: 'terms', value: ['large'] }],
    label: '6+ комнатная',
    shortLabel: '6+',
    state: 'large',
  },
  {
    form: [{ key: 'room', type: 'terms', value: ['studio'] }],
    label: 'Студия',
    shortLabel: 'Студия',
    state: 'studio',
  },
  {
    form: [{ key: 'room', type: 'terms', value: ['openPlan'] }],
    label: 'Свободная планировка',
    shortLabel: 'Свободная планировка',
    state: 'openPlan',
  },
);
